import React from "react";
import { useNavigate } from "react-router-dom";
import { appListItems } from "../explore_apps/AppList";

function PDFConverterAppListView() {
  //react router navigate
  const navigate = useNavigate(); //react router navigate

  //pdf converter items
  const convtItems = [3, 4, 6, 7, 8, 9, 10, 33, 5];

  return (
    <div className="mx-3">
      <div className="row row-cols-md-4 row-cols-sm-3 row-cols-1 justify-content-center mx-md-2 mx-0 mt-5">
        {appListItems
          .filter((item) => convtItems.includes(item.id))
          .map((appItem) => (
            <div
              key={appItem.id}
              className="bg-light m-md-1 m-sm-1 m-1 rounded-1 border"
              onClick={(e) => {
                //navigate
                navigate(appItem.navigate, { state: appItem.state }); //Navigate to new route
              }}
            >
              {/* Online offline circle */}
              <div className="d-flex justify-content-between mt-2 mb-2 ps-2 pe-2 pt-1 pb-1 justify-content-center align-items-center">
                {/* Name */}
                <div style={{ cursor: "pointer" }}>
                  {/* Image */}
                  <img
                    loading="lazy"
                    className="pb-1"
                    src="./images/circle-fill.svg"
                    alt="circle"
                    style={{
                      filter: appItem.online
                        ? "invert(48%) sepia(79%) saturate(2476%) hue-rotate(86deg) brightness(118%) contrast(119%)"
                        : "brightness(0) saturate(100%) invert(60%) sepia(63%) saturate(6138%) hue-rotate(165deg) brightness(99%) contrast(102%)",
                      width: "16px",
                      height: "auto",
                      maxWidth: "16px",
                    }}
                  ></img>
                  {/* Name */}
                  <label
                    className="fs-6 fw-bold ms-2"
                    style={{ cursor: "pointer" }}
                  >
                    {appItem.name}
                  </label>
                </div>
                {/* Right arrow */}
                <img
                  loading="lazy"
                  style={{ width: "10px", height: "16px" }}
                  src="./images/arrow_right.png"
                  alt=""
                />
              </div>
              <div style={{ cursor: "pointer" }}>
                <label
                  className="fs-7 text-muted ps-2 pe-4 pb-5"
                  style={{ cursor: "pointer" }}
                >
                  {appItem.subtitle}
                </label>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}

export default PDFConverterAppListView;
